import React, { useRef, useEffect } from "react";
import { Form, Input, Button, Modal } from "antd";
import { useTranslation } from "react-i18next";

const CreateDepartmentModel = ({ form, isShow, onFinish, onCancel }) => {
  const inputRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (isShow) {
      inputRef.current.focus({
        cursor: "start",
      });
    }
  }, [isShow]);
  return (
    <>
      <Modal
        title={t("createDepartment")}
        open={isShow}
        onCancel={onCancel}
        footer={null}
      >
        <Form form={form} onFinish={onFinish}>
          <Form.Item
            name="departmentName"
            label={t("departmentName")}
            rules={[{ required: true, message: t("validateSelectDepartment") }]}
            style={{ height: "45px" }}
          >
            <Input
              placeholder={t("placeHolderDepartmentName")}
              ref={inputRef}
            />
          </Form.Item>
          <Form.Item className="mt-2">
            <Button type="primary" htmlType="submit">
              {t("save")}
            </Button>
            <Button
              style={{ marginLeft: "10px" }}
              type="danger"
              onClick={onCancel}
            >
              {t("cancel")}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CreateDepartmentModel;
